// extracted by mini-css-extract-plugin
export default {"carousel":"LE-z"};